import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center cursor-pointer transition-colors"
      aria-label="返回顶部"
      title="返回顶部"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}